module.exports = __webpack_public_path__ + "static/img/Rory_Sloane_desktop.a6ec9d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rory_Sloane_desktop.jpg
// module id = pYqf
// module chunks = 0